import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Table } from "react-bootstrap";
import Grid from '@material-ui/core/Grid';
import { Card, Button } from "components";
import { CardHeader, CardText } from "material-ui/Card";
import { brown500, red500, white, orange800 } from "material-ui/styles/colors";
import RaisedButton from "material-ui/RaisedButton";
import { commonApiPost } from "egov-ui-kit/utils/api";
import ShowField from "./showField";
import get from "lodash/get";
//import { translate } from "../../common/common";
import { translate } from "./commons/common";
import Label from "egov-ui-kit/utils/translationNode";
import { toggleSnackbarAndSetText } from "egov-ui-kit/redux/app/actions";
import jp from "jsonpath";
import _ from "lodash";
import { getResultUrl } from "./commons/url";
import commonConfig from "config/common.js";
import { getTenantId, setReturnUrl, localStorageSet, localStorageGet } from "egov-ui-kit/utils/localStorageUtils";
import { LabelContainer } from "egov-ui-framework/ui-containers";
import {
  
  getLocalizationCodeValue
} from "../../../ui-utils/commons";
class ShowForm extends Component {
  state = {
    searchBtnText: <LabelContainer labelName="APPLY" labelKey="REPORTS_SEARCH_APPLY_LABEL" />,
    filterApplied: false,
    getResults: false,
    dateError: "",
  };

  toDateObj = (dateStr) => {
    var parts = dateStr.match(/(\d{4})\-(\d{2})\-(\d{2})/);
    return new Date(Date.UTC(+parts[1], parts[2] - 1, +parts[3]));
  };

  resetFields = () => {
    const { metaData, resetForm, searchForm, setSearchParams } = this.props;
    if (!searchForm) {
      return;
    } else {
      if (get(metaData, "reportDetails.searchParams")) {
        let searchParams = metaData.reportDetails.searchParams;
        var i;
        let fromDateIndex, toDateIndex;
        for (i = 0; i < searchParams.length; i++) {
          if (searchParams[i].name === "fromDate") {
            fromDateIndex = i;
          } else if (searchParams[i].name === "toDate") {
            toDateIndex = i;
          }
        }
        if (fromDateIndex !== undefined) searchParams[fromDateIndex].maxValue = new Date();
        if (toDateIndex !== undefined) {
          searchParams[toDateIndex].minValue = undefined;
          //searchParams[toDateIndex].maxValue = undefined;
          searchParams[toDateIndex].maxValue = new Date();;
        }
        setSearchParams(searchParams);
      }
      this.setState({ getResults: false, dateError: "" }, () => {
        resetForm();
      });
    }
  };

  checkForDependentSource = async (fieldIndex, field, selectedValue) => {
    const { pattern: fieldPattern, mapping, type: fieldType, name: targetProperty, isMandatory, displayOnly } = field;
    const { metaData, setMetaData, handleChange } = this.props;
    let splitArray = fieldPattern.split("?");
    let url = splitArray[0];
    let queryString = splitArray[1].split("|")[0].split("&");
    let queryJSON = {};

    for (var key in queryString) {
      let dat = queryString[key].split("=");
      if (dat[0] == "tenant-id") continue;
      if (dat[1].indexOf("{") > -1) {
        var path = dat[1].split("{")[1].split("}")[0];
        var pat = new RegExp("{" + path + "}", "g");
        queryJSON[dat[0]] = dat[1].replace(pat, selectedValue);
      } else {
        queryJSON[dat[0]] = dat[1];
      }
    }

    try {
      const response = await commonApiPost(url, queryJSON);
      let keys = jp.query(response, splitArray[1].split("|")[1]);
      let values = jp.query(response, splitArray[1].split("|")[2]);
      let defaultValue = {};
      for (var k = 0; k < keys.length; k++) {
        defaultValue[keys[k]] = values[k];
      }
      const defaultValuesLength = Object.keys(defaultValue).length;

      if (fieldType == "url") {
        metaData.reportDetails.searchParams[fieldIndex].defaultValue = defaultValue;
      } else {
        if (defaultValuesLength < 2) {
          metaData.reportDetails.searchParams[fieldIndex].disabled = true;
        }
      }

      setMetaData(metaData);

      if (defaultValuesLength && defaultValuesLength < 2) {
        const key = Object.keys(defaultValue)[0];
        const value = displayOnly ? defaultValue[key] : key;
        const e = { target: { value } };
        handleChange(e, targetProperty, isMandatory ? true : false, "");
      }
    } catch (error) {
      //alert("Something went wrong while loading depedent");
    }
  };
  handleDateSelect = (metaData, e, property) => {
    let { setSearchParams } = this.props;
    if (get(metaData, "reportDetails.searchParams")) {
      let searchParams = metaData.reportDetails.searchParams;
      var i;
      let fromDateIndex, toDateIndex;
      for (i = 0; i < searchParams.length; i++) {
        if (searchParams[i].name === "fromDate") {
          fromDateIndex = i;
        } else if (searchParams[i].name === "toDate") {
          toDateIndex = i;
        }
      }
      if (property === "fromDate" && toDateIndex !== undefined) {
        searchParams[toDateIndex].minValue = new Date(e.target.value);
      } else if (property === "toDate" && fromDateIndex !== undefined) {
        searchParams[fromDateIndex].maxValue = new Date(e.target.value);
      }
      setSearchParams(searchParams);
    }
  };
  handleChange = (e, property, isRequired, pattern) => {
    const { metaData, setMetaData, handleChange, searchForm } = this.props;
    const selectedValue = e.target.value;
    if (property === "fromDate" || property === "toDate") {
      this.handleDateSelect(metaData, e, property);
      this.checkDate(selectedValue, property, isRequired, pattern);
    } else {
      handleChange(e, property, isRequired, pattern);
    }

    if (metaData.hasOwnProperty("reportDetails") && metaData.reportDetails.searchParams.length > 0) {
      if (!selectedValue) {
        for (var l = 0; l < metaData.reportDetails.searchParams.length; l++) {
          if (metaData.reportDetails.searchParams[l].type == "url" && metaData.reportDetails.searchParams[l].pattern.search(property) > -1) {
            metaData.reportDetails.searchParams[l].defaultValue = {};
          }
        }
        setMetaData(metaData);
      } else {
        for (var i = 0; i < metaData.reportDetails.searchParams.length; i++) {
          const field = metaData.reportDetails.searchParams[i];
          const defaultValue = field.defaultValue;
          const fieldType = field.type;
          const dependantProperty = field.name;

          if (dependantProperty === property) {
            continue;
          }

          if (typeof defaultValue != "object" || field.hasOwnProperty("pattern")) {
            if (!field.hasOwnProperty("pattern")) {
              field["pattern"] = defaultValue;
            }

            const fieldPattern = field.pattern;

            if (fieldPattern.indexOf("{" + property + "}") == -1) continue;

            if (fieldPattern && fieldPattern.search("{" + property + "}") > -1) {
              this.checkForDependentSource(i, field, selectedValue);
            }
          }
        }
      }
    }
  };

  checkDate = (value, name, required, pattern) => {
    let e = {
      target: {
        value: value,
      },
    };

    if (name == "fromDate") {
      let startDate = value;
      if (this.props.searchForm) {
        try {
          let endDate = this.props.searchForm.toDate;
          this.props.handleChange(e, name, required, pattern);
          this.validateDate(startDate, endDate, required, "fromDate"); //3rd param to denote whether field fails
        } catch (e) {
          console.log(e);
        }
      } else {
        this.props.handleChange(e, name, required, pattern);
      }
    } else {
      let endDate = value;
      if (this.props.searchForm) {
        try {
          let startDate = this.props.searchForm.fromDate;
          this.props.handleChange(e, name, required, pattern);
          this.validateDate(startDate, endDate, required, "toDate"); //3rd param to denote whether field fails
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  validateDate = (startDate, endDate, required, field) => {
    if (startDate && endDate) {
      let sD = new Date(startDate);
      sD.setHours(0, 0, 0, 0);
      let eD = new Date(endDate);
      eD.setHours(0, 0, 0, 0);
      if (eD >= sD) {
        this.setState({ datefield: "" });
        this.setState({ dateError: "" });
      } else {
        let e = {
          target: {
            value: "",
          },
        };
        this.props.handleChange(e, field, required, "");
        this.setState({ datefield: field });
        this.setState({
          dateError:
            field === "toDate" ? (
              <Label labelStyle={{ color: "rgb(244, 67, 54)" }} label="REPORT_SEARCHFORM_DATE_GREATER" />
            ) : (
              <Label labelStyle={{ color: "rgb(244, 67, 54)" }} label="REPORT_SEARCHFORM_DATE_LESSER" />
            ),
        });
      }
    }
  };

  // set the value here, introduce the disabled
  handleFormFields = () => {
    let { metaData, searchForm ,labels} = this.props;
    let reportName="";
    if (!_.isEmpty(metaData) && metaData.reportDetails && metaData.reportDetails.searchParams && metaData.reportDetails.searchParams.length > 0) {
      reportName = !_.isEmpty(metaData) && metaData.reportDetails?metaData.reportDetails.reportName:reportName
      return metaData.reportDetails.searchParams.map((item, index) => {
        item["value"] = !_.isEmpty(searchForm) ? (searchForm[item.name] ? searchForm[item.name] : "") : "";
        if (item.type === "epoch" && item.minValue && item.maxValue && typeof item.minValue !== "object" && typeof item.maxValue !== "object") {
          item.minValue = this.toDateObj(item.minValue);
          item.maxValue = this.toDateObj(item.maxValue);
        } else if (item.type === "epoch" && item.name == "fromDate" && item.maxValue === null) {
          item.maxValue = new Date();
        }
        else if (item.type === "epoch" && item.name == "toDate" && item.maxValue === null) {
          item.maxValue = new Date();
        }
        if (item.type === "singlevaluelist") {
          item["searchText"] = !_.isEmpty(searchForm) ? (searchForm[item.name] ? searchForm[item.name] : "") : "";
        }
        return (
          item.name !== "tenantId" && (
            <ShowField
              value={item["value"]}
              key={index}
              obj={item}
              reportName={reportName}
              dateField={this.state.datefield}
              dateError={this.state.dateError}
              handler={this.handleChange}
              localizationLabels = {labels}
            />
          )
        );
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    let { changeButtonText, clearReportHistory, needDefaultSearch } = this.props;
    let { dateError } = this.state;

    if (!_.isEqual(this.props.searchForm, nextProps.searchForm)) {
      if (this.state.getResults) {
        this.search(null, false, nextProps.searchForm);
      }
      this.setState({ getResults: false, dateError: "" });
    }
    if (nextProps.metaData.reportDetails && nextProps.metaData.reportDetails !== this.props.metaData.reportDetails) {
      changeButtonText(<LabelContainer labelName="APPLY" labelKey="REPORTS_SEARCH_APPLY_LABEL" />);
      this.setState({
        reportName: nextProps.metaData.reportDetails.reportName,
      });
      let { reportName } = this.state;

      this.setState({ moduleName: this.props.match.params.moduleName });

      let { setForm } = this.props;
      let { searchParams } = !_.isEmpty(nextProps.metaData) ? nextProps.metaData.reportDetails : { searchParams: [] };
      let required = [];
      for (var i = 0; i < searchParams.length; i++) {
        if (searchParams[i].name !== "tenantId" && searchParams[i].isMandatory) {
          required.push(searchParams[i].name);
        }
        if (searchParams[i].initialValue) {
          if (searchParams[i].type === "epoch") {
            this.handleChange(
              { target: { value: this.toDateObj(searchParams[i].initialValue) } },
              searchParams[i].name,
              searchParams[i].isMandatory ? true : false,
              ""
            );
          } else {
            this.handleChange(
              { target: { value: searchParams[i].initialValue } },
              searchParams[i].name,
              searchParams[i].isMandatory ? true : false,
              ""
            );
          }
        }
      }
      setForm(required);
      clearReportHistory();
      if (!_.isEmpty(JSON.parse(localStorageGet("searchCriteria")))) {
        this.search(null, true, nextProps.metaData.reportDetails.reportName);
      } else if (needDefaultSearch) {
        this.defautSearch(null, false, nextProps.metaData.reportDetails.reportName, nextProps.match.params.moduleName);
      }
    }
  }

  componentDidMount() {
    let { metaData, setForm, changeButtonText, clearReportHistory } = this.props;
    changeButtonText(<LabelContainer labelName="APPLY" labelKey="REPORTS_SEARCH_APPLY_LABEL" />);
    let searchParams = !_.isEmpty(metaData) ? metaData.reportDetails : { searchParams: [] };
    let required = [];
    this.setState({ reportName: this.props.match.params.reportName });
    this.setState({ moduleName: this.props.match.params.moduleName });
    if (searchParams) {
      for (var i = 0; i < searchParams.length; i++) {
        if (searchParams[i].isMandatory) {
          required.push(searchParams[i].name);
        }
      }
    }

    setForm(required);
    clearReportHistory();
  }

  getDisplayOnlyFields = (metaData) => {
    return (
      metaData &&
      metaData.reportDetails &&
      metaData.reportDetails.searchParams &&
      metaData.reportDetails.searchParams.filter((field) => field.displayOnly).map((field) => field.name)
    );
  };
  defautSearch = (e = null, isDrilldown = false, rptName, moduleName) => {
    if (e) {
      e.preventDefault();
    }

    let {
      showTable,
      changeButtonText,
      setReportResult,
      searchForm,
      metaData, 
      setFlag,
      setSearchParams,
      reportHistory,
      reportIndex,
      pushReportHistory,
      clearReportHistory,
      decreaseReportIndex,
    } = this.props;
    let today = new Date();
    let date = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
    let tabLabel = `Showing data upto : ${date}`;
    this.props.updateTabLabel(tabLabel);

    var tenantId = getTenantId() ? getTenantId() : commonConfig.tenantId;
    let self = this;
    if (!isDrilldown) {
      const displayOnlyFields = this.getDisplayOnlyFields(metaData);

      let searchParams = [];

      clearReportHistory();
      let resulturl = getResultUrl(moduleName,rptName);
      let response =
        resulturl &&
        commonApiPost(resulturl, {}, { tenantId: tenantId, reportName: rptName || this.state.reportName, searchParams }).then(
          function(response) {
            pushReportHistory({ tenantId: tenantId, reportName: self.state.reportName, searchParams });
            setReportResult(response);
            showTable(true);
            setFlag(1);
          },
          function(err) {
            showTable(false);
            alert("Something went wrong or try again later");
          }
        );
    }

    changeButtonText(<LabelContainer labelName="APPLY" labelKey="REPORTS_SEARCH_APPLY_LABEL" />);
  };
   float2int (value) {
    return value | 0;
}
getReportCodeConfig=(ReportName)=>{
  let ReportCofigName = null;
  //"WaterReport"
  switch(ReportName){ 
    //PGR REPORTWISE CONFIG START    
      case "SourceWiseReport":
      ReportCofigName ="PGR_SOURCE_REPORT_DAY_VALIDATION"
      break;
      case "DescriptionReport":
      ReportCofigName ="PGR_DESCRIPTION_REPORT_DAY_VALIDATION"
      break;
      case "DescriptionReportSA":
      ReportCofigName ="PGR_DESCRIPTION_SA_REPORT_DAY_VALIDATION"
      break;
      case "ComplaintReport":
      ReportCofigName ="PGR_COMPLAINT_REPORT_DAY_VALIDATION"
      break;
      case "StateSourceReport":
      ReportCofigName ="PGR_STATE_SOURCE_REPORT_DAY_VALIDATION"
      break;
      case "EmployeeReport":
      ReportCofigName ="PGR_EMPLOYEE_REPORT_DAY_VALIDATION"
      break;
      case "EscalationOfficerReport":
      ReportCofigName ="PGR_ESCALATION_REPORT_DAY_VALIDATION"
      break;
      case "StateULBReport":
      ReportCofigName ="PGR_STATE_ULB_REPORT_DAY_VALIDATION"
      break;
      case "ComplaintTypesReport":
      ReportCofigName ="PGR_COMPLAINT_TYEPS_REPORT_DAY_VALIDATION"
      break;
      case "DepartmentReport1":
      ReportCofigName ="PGR_DEPARTMENT1_REPORT_DAY_VALIDATION"
      break;
      case "DepartmentReport":
      ReportCofigName ="PGR_DEPARTMENT_REPORT_DAY_VALIDATION"
      break;
      case "EmployeeWiseReport":
      ReportCofigName ="PGR_EMPLOYEE_WISE_REPORT_DAY_VALIDATION"
      break;
      case "GrievancesSLAAchievement":
      ReportCofigName ="PGR_GRIEVANCE_SLA_REPORT_DAY_VALIDATION"
      break;
      //PGR REPORTWISE CONFIG END
      case "ReceiptRegister":
      case "CancelledReceiptRegister":
      case "OldUlbWisePtCollection":
      case "StateCancelledReceiptRegister":
      case "StateWidePtCollection":
      case "UlbWisePtCollection":
      ReportCofigName ="PT_REPORT_DAY_VALIDATION"//6
      break;
      case "LicenseAndLeaseRenewalRegistryReport":
      case "StateTradeLicenseCancelledRegistryReport":
      case "TradeLicenseCancelledRegistryReport":
      case "LicenseWiseCollectionReport":
      case "LicenseAndLeaseRenewalApplicationStatusReport":
      case "TradeLicenseULBWiseApplicationStatusReport":
      case "StateLevelStatus":
      case "StateLevelTradeWiseCollection":
      case "StateLevelTradeLicenseRegistryReport":
      ReportCofigName ="TL_REPORT_DAY_VALIDATION"//9
      break;
      case "MISEventLocalityWiseReport":
      case "MISNumberOfEventReportReport":
      case "MISTimeSeriesDepartmentReportReport":
      case "MISTimeSeriesEventTypeReportReport":
      ReportCofigName ="PR_REPORT_DAY_VALIDATION"//4
      break;
      case "MISSummaryReport":
      case "RevenueCollectionReportApplicationTypeWise":
      case "RevenueCollectionReportMonthWise":
      case "ApplicationProcessingTimeReport":
      case "RevenueCollectionReportSectorWise":
      case "MISUtRoadcutSummaryReport":
      case "UtRoadcutRevenueCollectionReport":
      ReportCofigName ="PM_REPORT_DAY_VALIDATION"//7
      break;
      case "RegularNormalPension":
      case "PensionObligation":
      case "MonthlyPensionDrawn":
      case "DeathOfAnEmployee":
      case "DeathOfPensioner":
      case "EmployeeToBeRetired":
      case "EmployeeToBeRetired":
      case "OtherBankReport":
      ReportCofigName ="PENSION_REPORT_DAY_VALIDATION"//8
      break;
      case "OTApplicationStatusReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_OT"//14
        break;
      case "DCApplicationStatusReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_DC"//14
        break;
      case "MGApplicationStatusReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_MG"//14
        break;
      case "OTRegistryReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_OT_REGISTRY"//14
        break;
      case "DCRegistryReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_DC_REGISTRY"//14
        break;
      case "RPRentRegistryReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_RENT_REGISTRY"//14
        break;
      case "OTCollectionReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_OT_COLLECTION"//14
        break;
      case "DCCollectionReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_DC_COLLECTION"//14
        break;
      case "RPRentCollectionReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_RP_COLLECTION"//14
        break;
      case "RPDueAmountReport":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_RP_DUE"//14
        break;
      case "DCRegistryReportDashBoard":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_DC_REGISTRY"//14
        break;
      case "OTRegistryReportDashBoard":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_OT_REGISTRY"//14
        break;
      case "RPRentRegistryReportDashBoard":
        ReportCofigName ="RP_REPORT_DAY_VALIDATION_RP_RENT_REGISTRY"//14
        break;
      case "RPDueAmountReportDashBoard":     
      ReportCofigName ="RP_REPORT_DAY_VALIDATION_RP_DUE_AMOUNT"//14
      break;
      case "ESApplicationStatusReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_APPLICATION_STATUS"//14
      break;
      case "ESRegistryReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_REGISTRY"//14
      break;
      case "ESCollectionReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_COLLECTION"//14
      break;
      case "EstateRentRegistryReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_RENT_REGISTRY"//14
      break;
      case "EstatePenaltyRegistryReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_PENALTY_REGISTRY"//14
      break;
      case "EstateExtensionFeeRegistryReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_EXTENSION_FEE_REGISTRY"//14
      break;
      case "EstateSecurityDepositRegistryReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_SEQ_DEPOSIT_REGISTRY"//14
      break;
      case "EstateRentCollectionReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_RENT_COLLECTION"//14
      break;
      case "EstatePenaltyCollectionReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_PENALTY_COLLECTION"//14
      break;
      case "EstateExtensionFeeCollectionReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_EXTENSION_FEE"//14
      break;
      case "EstateSecurityDepositCollectionReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_SEQ_DEPOSITE"//14
      break;
      case "EstateRentDueReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_RENT_DUE"//14
      break;
      case "EstateCourtCaseReport":
        ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_COURT_CASE"//14
      break;
      case "EstateCourtCaseDetailsReport":     
      ReportCofigName ="ESTATE_REPORT_DAY_VALIDATION_COURT_CASE_DETAILS"//14
      break;
      case "BookingsApplicationStatusReport":
      case "BookingWiseCollectionReport":
      case "AllBookingsTransactionReport":
      case "AllBookingsReport":
      case "DescriptionReport":
      case "PaymentReport":
      case "BlockingVenueReport":
      case "DescriptionReportCount":
      ReportCofigName ="BK_REPORT_DAY_VALIDATION"//8
      break;
      case "HorticultureReport":
      case "hcReportMCC":
      case "hcReportUT":
      case "hcReportFR":
      ReportCofigName ="HC_REPORT_DAY_VALIDATION"//4
      break;
      case "SEPWiseReport":
      case "SMIDWiseReport":
      case "SUSVWiseReport":
      ReportCofigName ="NULM_REPORT_DAY_VALIDATION"//3
      break;
      case "SterilizationReport":
      case "MISUtRoadcutSummaryReport":
      case "UtRoadcutRevenueCollectionReport":
      ReportCofigName ="OPMS_REPORT_DAY_VALIDATION"//3
      break;     
      case "WaterReport":
      case "SewerageReport":
        ReportCofigName ="WATER_REPORT_DAY_VALIDATION"//1
        break;
      default:
        ReportCofigName ="DEFAULT_REPORT_DAY_VALIDATION"//DEFAULT
      break;


  }
   
  return ReportCofigName;

}
  search = (e = null, isDrilldown = false, searchForm) => {
    if (e) {
      e.preventDefault();
    }

    let {
      showTable,
      changeButtonText,
      setReportResult,
      metaData,
      setFlag,
      setSearchParams,
      reportHistory,
      reportIndex,
      pushReportHistory,
      clearReportHistory,
      decreaseReportIndex,
      ReportDay,
      stateInfoById,
      toggleSnackbarAndSetText
    } = this.props;
    let searchParams = [];
    var tenantId = getTenantId() ? getTenantId() : commonConfig.tenantId;
    let self = this;
    let mandatoryfields=[]
    metaData.reportDetails.searchParams.forEach(param=>{
      if(param.isMandatory){
        mandatoryfields.push(param.name);
      }
    });
    let filledMandatoryFieldsCount=searchForm ? Object.keys(searchForm)
    .filter(param => mandatoryfields.includes(param)).length:0;
    if(filledMandatoryFieldsCount!=mandatoryfields.length)
    { 
      toggleSnackbarAndSetText(true,{labelKey:"COMMON_MANDATORY_MISSING_ERROR",labelName:"Please fill all mandatory fields to search"},
      "error");
      return;
    }
    let reportName = ""
    let validDate = true;
    if(metaData && metaData.reportDetails)
    {
       reportName = metaData.reportDetails.reportName
    }
    let fromDate =0
      let toDate = 0
      for (var variable in searchForm) {
        if (variable == "fromDate") {
          try {
            fromDate = searchForm[variable].setHours(0);
            fromDate = searchForm[variable].setMinutes(0);
            fromDate = searchForm[variable].setSeconds(0);
          } catch (e) {
            console.log(e);
          }
        } else if (variable == "toDate") {
          try {
            toDate = searchForm[variable].setHours(23);
            toDate = searchForm[variable].setMinutes(59);
            toDate = searchForm[variable].setSeconds(59);
          } catch (e) {
            console.log(e);
          }
        }
      }
      let days =( (toDate- fromDate) / (1000 * 60 * 60 * 24) +1);
      days = this.float2int(days)
      let Days = 0
      let ReportConfigCode = ''
      ReportConfigCode = this.getReportCodeConfig(reportName)
      if(ReportDay && ReportDay.length>0)
        {
          ReportDay = ReportDay.filter(x=>x.code ===ReportConfigCode) 
          if(ReportDay && ReportDay[0])
          {
            Days = ReportDay[0].validDay
          }
          
        }
        else
        {
          if(stateInfoById && stateInfoById[0])
          {
            Days = stateInfoById[0].validDay
          }
        }
    // if(reportName ==="WaterReport")
    // {
    //   Days=93;
    //   if(ReportDay && ReportDay.length>0)
    //   {
    //     ReportDay = ReportDay.filter(x=>x.code ==='WATER_REPORT_DAY_VALIDATION') 
    //     if(ReportDay && ReportDay[0])
    //     {
    //       Days = ReportDay[0].validDay
    //     }
        
    //   }
    //   else
    //   {
    //     if(stateInfoById && stateInfoById[0])
    //     {
    //       Days = stateInfoById[0].watervalidDay
    //     }
    //   }     
      

    // }
    if( Days >0 && days>Days)
      {
        validDate = false;
       
      }
    if(validDate === false)
    {
      showTable(false);
      const LocalizationCodeValueStart = getLocalizationCodeValue("COMMON_INVALID_DATE_RANGE_ERROR")
      const LocalizationCodeValueEnd = getLocalizationCodeValue("COMMON_INVALID_DATE_RANGE_DAYS")
      // const LocalizationCodeValueStart = getLocalizationCodeValue("Date range should be less then")
      // const LocalizationCodeValueEnd = getLocalizationCodeValue("Days")
      //Dynamic Message using localization code and configuration value
      let labelKey =  `${LocalizationCodeValueStart} ${Days+1} ${LocalizationCodeValueEnd}`
      toggleSnackbarAndSetText(true,{labelKey:labelKey,labelName:"Date range should be less then 6 month"},
      "warning");
      return;
    }
    if(validDate && validDate === true)
    {
    if (!isDrilldown) {
      const displayOnlyFields = this.getDisplayOnlyFields(metaData);
      
      searchForm = searchForm
        ? Object.keys(searchForm)
            .filter((param) => !_.includes(displayOnlyFields, param))
            .reduce((acc, param) => {
              acc[param] = searchForm[param];
              return acc;
            }, {})
        : searchForm;

      for (var variable in searchForm) {
        let input;
        
        if (this.state.moduleName == "pgr") {
          if (variable == "fromDate") {
            input =
              searchForm[variable].getFullYear() +
              "-" +
              (searchForm[variable].getMonth() > 8 ? searchForm[variable].getMonth() + 1 : "0" + parseInt(searchForm[variable].getMonth() + 1)) +
              "-" +
              (searchForm[variable].getDate() > 9 ? searchForm[variable].getDate() : "0" + searchForm[variable].getDate()) +
              " 00:00:00";
          } else if (variable == "toDate") {
            input =
              searchForm[variable].getFullYear() +
              "-" +
              (searchForm[variable].getMonth() > 8 ? searchForm[variable].getMonth() + 1 : "0" + parseInt(searchForm[variable].getMonth() + 1)) +
              "-" +
              (searchForm[variable].getDate() > 9 ? searchForm[variable].getDate() : "0" + searchForm[variable].getDate()) +
              " 23:59:59";
          } else {
            input = searchForm[variable];
          }
        } else {
          if (variable == "fromDate") {
            try {
              input = searchForm[variable].setHours(0);
              input = searchForm[variable].setMinutes(0);
              input = searchForm[variable].setSeconds(0);
            } catch (e) {
              console.log(e);
            }
          } else if (variable == "toDate") {
            try {
              input = searchForm[variable].setHours(23);
              input = searchForm[variable].setMinutes(59);
              input = searchForm[variable].setSeconds(59);
            } catch (e) {
              console.log(e);
            }
          } else {
            input = searchForm[variable];
          }
        }
        if (input && input != "All") {
          searchParams.push({ name: variable, input });
        }
      }

      setSearchParams(searchParams);

      clearReportHistory();
      let resulturl = getResultUrl(this.state.moduleName,this.state.reportName);
      let response =
        resulturl &&
        commonApiPost(resulturl, {}, { tenantId: tenantId, reportName: this.state.reportName, searchParams }).then(
          function(response) {
            pushReportHistory({ tenantId: tenantId, reportName: self.state.reportName, searchParams });
            setReportResult(response);
            showTable(true);
            setFlag(1);
          },
          function(err) {
            showTable(false);
            alert("Something went wrong or try again later");
          }
        );
    } else {
      if (_.isEmpty(JSON.parse(localStorageGet("searchCriteria")))) {
        let reportData = reportHistory[reportIndex - 1 - 1];
        let resulturl = getResultUrl(this.state.moduleName,this.state.reportName);
        let response =
          resulturl &&
          commonApiPost(resulturl, {}, { ...reportData }).then(
            function(response) {
              decreaseReportIndex();
              setReportResult(response);

              showTable(true);
              setFlag(1);
            },
            function(err) {
              showTable(false);
              alert("Something went wrong or try again later");
            }
          );
      } else {
        var reportData = JSON.parse(localStorageGet("searchCriteria"));
        let resulturl = getResultUrl(localStorageGet("moduleName"));
        let response =
          resulturl &&
          commonApiPost(resulturl, {}, { ...reportData }).then(
            function(response) {
              setReturnUrl("");
              localStorageSet("searchCriteria", JSON.stringify({}));
              localStorageSet("moduleName", "");
              for (var i = 0; i < reportData.searchParams.length; i++) {
                self.handleChange({ target: { value: reportData.searchParams[i].name } }, reportData.searchParams[i].input, false, false);
              }
              setSearchParams(reportData.searchParams);
              setReportResult(response);

              showTable(true);
              setFlag(1);
            },
            function(err) {
              showTable(false);
              alert("Something went wrong or try again later");
            }
          );
      }
    }
  }

    changeButtonText(<LabelContainer labelName="APPLY" labelKey="REPORTS_SEARCH_APPLY_LABEL" />);
  };

  fetchResults = (e, searchForm) => {
    let { search } = this;
    let fromDate;
    let toDate;
    if (searchForm && searchForm.fromDate && searchForm.toDate) {
      fromDate = new Date(searchForm.fromDate);
      toDate = new Date(searchForm.toDate);
    }

    let tabLabel = "";
    if (fromDate && toDate) {
      tabLabel = `Showing data for : ${fromDate.getDate() + "/" + (fromDate.getMonth() + 1) + "/" + fromDate.getFullYear()} to ${toDate.getDate() +
        "/" +
        (toDate.getMonth() + 1) +
        "/" +
        toDate.getFullYear()}`;
    }
    // Tab Lable for Year and Month Selection in pension module for Monthly Pension Drawn start
    let Year;
    let Month;
    if (searchForm && searchForm.Year && searchForm.Month) {
      Year = searchForm.Year;
      Month = searchForm.Month;
      switch(Month)
      {
        case "1":
          Month= "January"
        break;
        case "2":
          Month= "February"
        break;
        case "3":
          Month= "March"
        break;
        case "4":
          Month= "April"
        break;
        case "5":
          Month= "May"
        break;
        case "6":
          Month= "June"
        break;
        case "7":
          Month= "July"
        break;
        case "8":
          Month= "August"
        break;
        case "9":
          Month= "September"
        break;
        case "10":
          Month= "October"
        break;
        case "11":
          Month= "November"
        break;
        case "12":
          Month= "December"
        break;
      }
      tabLabel =`Showing data for : Selected Year : ${Year}  Selected Month : ${Month}`

    }

    // End

    /** Zone wise selection show in header */
    if (searchForm && searchForm.hasOwnProperty("ZonalSelection")) {
      if (searchForm.ZonalSelection.hasOwnProperty("Zone")) {
        tabLabel += ` <b>Zone:</b> ${searchForm.ZonalSelection.Zone}`;
      }
      if (searchForm.ZonalSelection.hasOwnProperty("Block")) {
        tabLabel += ` <b>Block:</b> ${searchForm.ZonalSelection.Block}`;
      }
      if (searchForm.ZonalSelection.hasOwnProperty("Locality")) {
        tabLabel += ` <b>Locality:</b> ${searchForm.ZonalSelection.Locality}`;
      }
    }
    /** END Zone wise ... */

    this.props.updateTabLabel(tabLabel);
    search(e, false, searchForm);
  };

  getReportTitle = (rptName,isLocalisationRequired = false) => {
    let reportName = rptName || this.state.reportName;
    let reportTitleArr = reportName && reportName.split(/(?=[A-Z])/);
    let reportTitle = "";
    if(rptName == 'ULBDepartmentReport'){
      reportTitle = "Department Report"
    }
    else if (rptName == "ULBEmployeeWiseReport"){
      reportTitle = "Employee Wise Report"
    }
    else if (reportTitleArr) {
      reportTitle = reportTitleArr.map((char) => {
        if (char.length == 1) {
          reportTitle = char + "";
        } else {
          reportTitle = " " + char;
        }
        return reportTitle;
      });
    }
    // if(isLocalisationRequired && isLocalisationRequired === true)
    // {
    //   reportTitle = reportName
    //   return reportTitle;
    // }
    return reportTitle;
  };

  getReportTitlefromTwoOptions = (metaData) => {
    if (get(metaData, "reportDetails.additionalConfig[0].reportTitle")) {
      if(metaData.reportDetails.additionalConfig[0].isLocalisationRequired && metaData.reportDetails.additionalConfig[0].isLocalisationRequired === true )
      {
        return (
          <Label
            label={`RPT_${metaData.reportDetails.additionalConfig[0].reportTitle}`}
            labelStyle={{ marginLeft: "16px", marginTop: "8px", color: "#484848" }}
            fontSize={20}
          />
        );

      }
      else
      {
        return (
          <Label
            label={metaData.reportDetails.additionalConfig[0].reportTitle}
            labelStyle={{ marginLeft: "16px", marginTop: "8px", color: "#484848" }}
            fontSize={20}
          />
        );

      }
      
    } else {
      let isLocalisationRequired = get(metaData, "reportDetails.reportHeader[0].isLocalisationRequired")//false
      return (
        
        get(metaData, "reportDetails.reportName") && <div className="report-title">{this.getReportTitle(metaData.reportDetails.reportName,isLocalisationRequired)}</div>
      );
    }
  };

  render() {
    let { buttonText, metaData, reportIndex, searchForm } = this.props;
    let { search } = this;
    const { common } = this.state;
    return (
      <div className="">
        {metaData && metaData.reportDetails && (
          <form
            onSubmit={(e) => {
              this.fetchResults(e, searchForm);
            }}
          >
            <div>{metaData && this.getReportTitlefromTwoOptions(metaData)}</div>
            <Card
              style={{ padding: "16px" }}
              textChildren={
                <div>
                   {(metaData.reportDetails.reportName==="RPDueAmountReport")?<Label label={"RP_REPORTS_SEARCHFORM_MODIFY_COLONY_HEADER"} />:<Label label={"REPORTS_SEARCHFORM_MODIFY_DATE_HEADER"} />}
                  <Grid container spacing={8}>{this.handleFormFields()}</Grid>
                  <Row>
                    <div style={{ marginTop: "16px", textAlign: "center" }} className="col-xs-12">
                      <RaisedButton
                        // style={{ height: "48px",borderRadius: "2px", width: "80%", backgroundColor: "rgba(0, 0, 0, 0.6)" }}
                        type="submit"
                        //disabled={!isFormValid}
                        primary={true}
                        label={buttonText}
                      />
                      <RaisedButton
                        style={{ marginLeft: "8px" }}
                        type="button"
                        //disabled={!isFormValid}
                        // primary={true}
                        onClick={(e) => {
                          this.resetFields();
                        }}
                        label={<LabelContainer labelName="RESET" labelKey="REPORTS_SEARCH_RESET_LABEL" />}
                      />
                    </div>
                  </Row>
                </div>
              }
            />
          </form>
        )}

        {reportIndex > 1 && (
          <div
            style={{
              textAlign: "right",
              paddingRight: "15px",
            }}
          >
            <br />
            <RaisedButton
              type="button"
              onClick={(e) => {
                search(e, true);
              }}
              primary={true}
              label={"Back"}
            />
            <br />
            <br />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const labels = get(state.app , "localizationLabels")
  const { common } = state;
  const { ReportDay } = common;
  return {
    searchForm: state.formtemp.form,
    fieldErrors: state.formtemp.fieldErrors,
    isFormValid: state.formtemp.isFormValid,
    isTableShow: state.formtemp.showTable,
    buttonText: state.formtemp.buttonText,
    metaData: state.report.metaData,
    reportHistory: state.report.reportHistory,
    reportIndex: state.report.reportIndex,
    labels
  };
};

const mapDispatchToProps = (dispatch) => ({
  setForm: (required = [], pattern = []) => {
    dispatch({
      type: "SET_FORM",
      formtemp: {},
      fieldErrors: {},
      isFormValid: required.length > 0 ? false : true,
      validationData: {
        required: {
          current: [],
          required: required,
        },
        pattern: {
          current: [],
          required: [],
        },
      },
    });
  },
  handleChange: (e, property, isRequired, pattern) => {
    dispatch({
      type: "HANDLE_CHANGE",
      property,
      value: e.target.value,
      isRequired,
      pattern,
    });
  },
  resetForm: () => {
    dispatch({ type: "RESET_FORM" });
  },
  showTable: (state) => {
    dispatch({ type: "SHOW_TABLE", state });
  },
  changeButtonText: (text) => {
    dispatch({ type: "BUTTON_TEXT", text });
  },
  setReportResult: (reportResult) => {
    dispatch({ type: "SET_REPORT_RESULT", reportResult });
  },
  setFlag: (flag) => {
    dispatch({ type: "SET_FLAG", flag });
  },
  toggleSnackbarAndSetText:(open,message,type)=>{
   dispatch(toggleSnackbarAndSetText(
    open,message,type
  )) 
  },
  setMetaData: (metaData) => {
    dispatch({ type: "SET_META_DATA", metaData });
  },
  setSearchParams: (searchParams) => {
    dispatch({ type: "SET_SEARCH_PARAMS", searchParams });
  },
  pushReportHistory: (history) => {
    dispatch({ type: "PUSH_REPORT_HISTORY", reportData: history });
  },
  clearReportHistory: () => {
    dispatch({ type: "CLEAR_REPORT_HISTORY" });
  },
  decreaseReportIndex: () => {
    dispatch({ type: "DECREASE_REPORT_INDEX" });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowForm);



// WEBPACK FOOTER //
// ./src/modules/employee/reports/searchForm.js